import Icon from '../../../../playerView/components/Icon'
import { COLOR_GREEN } from '../../../constants';


// Player or Monster
const IconExample = ({currentEncounter, creatureType, iconOptions}) => {
    let isPlayer = creatureType === "player";
    let isAlly = creatureType === 'ally';

    const fallBackCreature = {
            "name": isPlayer ? "Skirk" : isAlly ? "Mastiff" : "Lowarnizel",
            "size": "Medium",
            "type": creatureType,
            "border": isPlayer ? COLOR_GREEN : isAlly ? "#649609ff" : "#D44E3B",
            "hidden": false,
            "effectObjs": [],
            "alignment": isPlayer || isAlly ? "ally" : "enemy",
            "avatarUrl": isPlayer ? "https://www.dndbeyond.com/avatars/34139/129/1581111423-93720713.jpeg?width=150&height=150&fit=crop&quality=95&auto=webp" : creatureType === 'ally' ? "https://www.dndbeyond.com/avatars/43939/692/638607428415948051.jpeg" : "https://www.dndbeyond.com/avatars/36576/606/638291908565779269.jpeg",
            "groupGuid": null,
            "hit_points": 168,
            "initiative": 25,
            "armor_class": "18",
            "inspiration": false,
            "bardic_inspiration": false,
            "creatureGuid": "EXAMPLE",
            "exhaustionLvl": 0,
            "dnd_b_player_id": null,
            "hit_points_temp": 0,
            "dmb_homebrew_guid": null,
        }

    let exampleCreature;
    if(creatureType === 'player')
        exampleCreature = currentEncounter.creatures.find(c => c.type === 'player')
    else if(creatureType === 'ally') {
        exampleCreature = currentEncounter.creatures.find(c => (c.alignment === 'ally' || c.alignment === 'pet') && c.type !== 'player')
    } else if(creatureType === 'monster') {
        exampleCreature = currentEncounter.creatures.find(c => (c.type === 'monster' && c.alignment === 'enemy'))
    } 

    if(!exampleCreature) {
        exampleCreature = fallBackCreature;
    }

    // -2 is to provide better user feedback
    let teamSize = iconOptions.teamSize-2;
    if(teamSize < -4) {
        teamSize = -4;
    } else if(teamSize > 0) {
        teamSize = 0;
    }

    let name = exampleCreature.name
    if(iconOptions.showName === false && iconOptions.showName != undefined) {
        name = "Creature 1"
    }

    return (
        <Icon 
            creature={{...exampleCreature, name: name, hit_points_current: Math.floor(exampleCreature.hit_points*.40)}} 
            isTurn={false} 
            iconOptions={{...iconOptions,teamSize: teamSize }}
            iconSize={{width: 150, height: 180}}
        />
    );
}

export default IconExample;